import * as types from '@/store/mutation-types';
import store from '@/store';
import { sectionType } from '@/helpers/enums';
export default {
	namespaced: true,

	state: {
		configurations: {
			staffConfig: {},
			customersConfig: {},
			materialsConfig: {},
			visitsConfig: {}
		},
		allConfigurations: [],
		customersTypesConf: [],
		customerType: [],

		fieldsInStaff: [],
		fieldsRoleInStaff: [],

		fieldsCustomer: [],
		fieldsCustomersTypes: [],

		fieldsMaterials: [],
		fieldsVisits: [],
		roleEmployee: {},

		weeklyPlan: false,
		systemConfigValue: [],
		lockPlanBeforeDays: null,

		fieldsCustomersTypesForVisits: [],
		visitsConfigByCustomerType: [],
	},

	actions: {
		fetchAll ({ commit }) {
			const items = [
				// staff
				{
					section: 1,
					key: null,
					data: store.state.configurations.fieldsInStaff,
					configId: null
				},
				// customers
				{
					section: 2,
					key: null,
					data: store.state.configurations.fieldsCustomer,
					configId: null
				},
				// visits
				{
					section: 4,
					key: null,
					data: store.state.configurations.fieldsVisits,
					configId: null
				},
				// materials
				{
					section: 3,
					key: null,
					data: store.state.configurations.fieldsMaterials,
					configId: null
				}
			];
			// console.log('store.state.configurations.fieldsMaterials', store.state.configurations.fieldsMaterials)
			// console.log('store.state.configurations.fieldsVisits', store.state.configurations.fieldsVisits)
			// console.log('store.state.configurations.fieldsCustomer', store.state.configurations.fieldsCustomer)
			// console.log('store.state.configurations.fieldsInStaff', store.state.configurations.fieldsInStaff)
			for (let k = 0; k < store.state.entities.customersTypes.length; k++) {
				items.push({
					section: 2,
					key: store.state.entities.customersTypes[k]?.id,
					data: JSON.parse(JSON.stringify(store.state.configurations.fieldsCustomersTypes)),
					configId: null
				})
			}

			for (let k = 0; k < store.state.entities.customersTypes.length; k++) {
				items.push({
					section: 4,
					key: store.state.entities.customersTypes[k]?.id,
					data: JSON.parse(JSON.stringify(store.state.configurations.fieldsCustomersTypesForVisits)),
					configId: null
				})
			}

			// for (let j = 0; j < store.state.rolePermission.roles.length; j++) {
			items.push({
				section: 1,
				key: Math.random(),
				// key: store.state.rolePermission.roles[j]?.id,
				data: JSON.parse(JSON.stringify(store.state.configurations.fieldsRoleInStaff)),
				configId: null
			})
			// }
			return window.axios.get('/Configuration').then(({ data }) => {
				// console.log('data conn', data)
				for (let i = 0; i < items.length; i++) {
					const getSection = data.find(c => c.section === items[i].section && c.key === items[i].key)

					if (
						getSection &&
						(
							data.find(c => c.section === items[i].section && c.key === items[i].key).id !== null &&
							data.find(c => c.section === items[i].section && c.key === items[i].key).id !== undefined
						)
					) {
						items[i].configId = data.find(c => c.section === items[i].section && c.key === items[i].key)?.id

						const itemPer = !(items[i].section === 'Customer' && items[i].key === null) ? items[i].data : store.state.entities.customersTypes

						const valuesArray = items[i] ? data.find(c => c.section === items[i].section && c.key === items[i].key).values.split(',').map(Number) : []

						for (let j = 0; j < itemPer?.length; j++) {
							if (valuesArray.find(c => c === itemPer[j].value)) {
								itemPer[j].booleanValue = true
								itemPer[j].key = items[i].key
								itemPer[j].configId = data.find(c => c.section === items[i].section && c.key === items[i].key).id
							} else {
								itemPer[j].booleanValue = false
								itemPer[j].key = items[i].key
								itemPer[j].configId = data.find(c => c.section === items[i].section && c.key === items[i].key).id
							}
						}
					} else {
						for (let k = 0; k < items[i].data.length; k++) {
							items[i].data[k] = {
								name: items[i].data[k].name,
								value: items[i].data[k].value,
								isMain: items[i].data[k].isMain,
								representativeType: items[i].data[k].representativeType,
								key: items[i].key,
								booleanValue: false
							}
						}
					}
				}
				// console.log('itema', items)
				const staffConfig = items.find(c => c.section === sectionType.staff)?.data.reduce((acc, item) => {
					acc[item.name] = item.booleanValue;
					return acc;
				}, {});
				// console.log('staffConfig', 'item staffConfig', staffConfig)
				// customers
				const customersConfig = items.find(c => c.section === sectionType.customers)?.data?.reduce((acc, item) => {
					acc[item.name] = item.booleanValue;
					return acc;
				}, {});

				// materials
				const materialsConfig = items.find(c => c.section === sectionType.materials)?.data.reduce((acc, item) => {
					acc[item.name] = item.booleanValue;
					return acc;
				}, {})

				// visits
				const visitsConfig = items.find(c => c.section === sectionType.visits)?.data.reduce((acc, item) => {
					acc[item.name] = item.booleanValue;
					return acc;
				}, {})
				// customer type
				const customerType = items.filter(c => c.section === sectionType.customers && c.key !== null).map(c => ({
					...c,
					data: c?.data.reduce((acc, item) => {
						acc[item.name] = item.booleanValue;
						return acc
					}, {}),
					key: c.key
				}))
				console.log('customerTypecustomerType', customerType)
				const visitsConfigByCustomerType = items
					.filter(c => c.section === sectionType.visits && c.key !== null)
					.map(c => {
						const fields = (c?.data || []).map(item => ({
							name: item.name,
							value: item.value,
							booleanValue: item.booleanValue,
							representativeType: item.representativeType || 'Both',
						}))

						return {
							...c,
							data: fields.reduce((acc, item) => {
								acc[item.name] = item.booleanValue;
								return acc
							}, {}),
							fields,
							key: c.key
						}
					})

				// employee role
				const roleEmployee = items.filter(c => c.section === sectionType.staff && c.key !== null).map(c => ({
					...c,
					data: c?.data.reduce((acc, item) => {
						acc[item.name] = item.booleanValue;
						return acc
					}, {}),
					key: c.key
				}))

				// console.log('alll', staffConfig, customersConfig, materialsConfig, visitsConfig)

				const configurations = { staffConfig, customersConfig, materialsConfig, visitsConfig }

				commit(types.STORE_CONFIGURATION, configurations)
				commit(types.STORE_CON_TYPES, customerType)
				commit(types.STORE_ROLE_EMPLOYEE, roleEmployee)
				commit(types.STORE_ALL_CONFIGURATION, items)
				commit(types.STORE_VISITS_CONFIG_BY_CUSTOMER_TYPE, visitsConfigByCustomerType)
				commit(types.STORE_WEEKLY_PLAN, JSON.parse(data.find(c => c.key === 'WeeklyPlan')?.values))
				commit(types.STORE_LOCK_VISIT_AFTER_DURATION, JSON.parse(data.find(c => c.key === 'LockVisitAfterDuration')?.values))
				return items
			})
		},

		fetchEnum ({ commit }) {
			return window.axios.get('/configuration/systemSectionsAndValues').then(({ data }) => {
				const staff = data.items.find(c => c.name === 'Staff').children.filter(d => d.isMain === true)
				const roleInStaff = data.items.find(c => c.name === 'Staff').children.filter(d => d.isMain === false)

				const customers = data.items.find(c => c.name === 'Customer').children.filter(d => d.isMain === true)
				const customersTypes = data.items.find(c => c.name === 'Customer').children.filter(d => d.isMain === false)

				const materialsFields = data.items.find(c => c.name === 'Materials').children

				const visitsFields = data.items.find(c => c.name === 'Visits').children

				const customersTypesForVisits = data.items.find(c => c.name === 'Visits').children.filter(d => d.isMain === false)

				commit(types.STORE_FIELDS_IN_STAFF, staff)
				commit(types.STORE_ROLE_IN_STAFF, roleInStaff)

				commit(types.STORE_FIELDS_IN_CUSTOMERS, customers)
				commit(types.STORE_TYPES_OF_CUSTOMERS, customersTypes)

				commit(types.STORE_FIELDS_IN_MATERIALS, materialsFields)
				commit(types.STORE_FIELDS_IN_VISITS, visitsFields)

				commit(types.STORE_FIELDS_IN_CUSTOMERS_TYPES_FOR_VISITS, customersTypesForVisits)
			})
		},

		fetchCurrentTime ({ commit }) {
			return window.axios.get('/currentTime').then(({ data }) => {
				commit(types.STORE_CURRENT_TIME, data)
			})
		},

		fetchSystemConfigValue ({ commit }) {
			return window.axios.get('/configuration/systemConfigurationValues').then(({ data }) => {
				// console.log('data', data)
				commit(types.STORE_SYSTEM_CONFIG_VALUE, data)

				const lockPlanBeforeDays = data.properties?.find(c => c.key === 'LockPlanBeforeDays')?.value === 'null' ? null : data.properties?.find(c => c.key === 'LockPlanBeforeDays')?.value
				// console.log('lockPlanBeforeDays', lockPlanBeforeDays)

				commit(types.LOCK_PLAN_BEFORE_DAYS, lockPlanBeforeDays)
				return data
			})
		}
	},

	mutations: {
		[types.STORE_CURRENT_TIME] (state, serverTime) {
			state.serverTime = serverTime
		},
		[types.STORE_CONFIGURATION](state, configurations) {
			state.configurations = configurations
		},

		[types.STORE_CUSTOMERS_TYPES_CONFIG] (state, customersTypesConf) {
			state.customersTypesConf = customersTypesConf
		},

		[types.STORE_CON_TYPES] (state, customerType) {
			state.customerType = customerType
		},
		// enums
		[types.STORE_FIELDS_IN_STAFF] (state, fieldsInStaff) {
			state.fieldsInStaff = fieldsInStaff
		},

		[types.STORE_ROLE_IN_STAFF] (state, fieldsRoleInStaff) {
			state.fieldsRoleInStaff = fieldsRoleInStaff
		},

		[types.STORE_FIELDS_IN_CUSTOMERS] (state, fieldsCustomer) {
			state.fieldsCustomer = fieldsCustomer
		},

		[types.STORE_TYPES_OF_CUSTOMERS] (state, fieldsCustomersTypes) {
			state.fieldsCustomersTypes = fieldsCustomersTypes
		},
		[types.STORE_FIELDS_IN_MATERIALS] (state, fieldsMaterials) {
			state.fieldsMaterials = fieldsMaterials
		},
		[types.STORE_FIELDS_IN_VISITS] (state, fieldsVisits) {
			state.fieldsVisits = fieldsVisits
		},

		[types.STORE_ALL_CONFIGURATION] (state, allConfigurations) {
			state.allConfigurations = allConfigurations
		},

		[types.STORE_ROLE_EMPLOYEE] (state, roleEmployee) {
			state.roleEmployee = roleEmployee
		},

		[types.STORE_WEEKLY_PLAN] (state, weeklyPlan) {
			state.weeklyPlan = weeklyPlan
		},

		[types.STORE_LOCK_VISIT_AFTER_DURATION] (state, lockVisitAfterDuration) {
			state.lockVisitAfterDuration = lockVisitAfterDuration
		},

		[types.RESET] (state) {
			state.configurations = {}
			state.customersTypesConf = []
			state.customerType = []
			state.fieldsInStaff = []
			state.fieldsRoleInStaff = []
			state.fieldsCustomer = []
			state.fieldsCustomersTypes = []
			state.fieldsCustomersTypesForVisits = []
			state.fieldsMaterials = []
			state.fieldsVisits = []
			state.allConfigurations = []
			state.roleEmployee = {}
			state.systemConfigValue = []
			state.visitsConfigByCustomerType = []
		},

		[types.STORE_SYSTEM_CONFIG_VALUE] (state, systemConfigValue) {
			state.systemConfigValue = systemConfigValue
		},

		[types.LOCK_PLAN_BEFORE_DAYS] (state, lockPlanBeforeDays) {
			state.lockPlanBeforeDays = lockPlanBeforeDays
		},

		[types.STORE_FIELDS_IN_CUSTOMERS_TYPES_FOR_VISITS] (state, fieldsCustomersTypesForVisits) {
			state.fieldsCustomersTypesForVisits = fieldsCustomersTypesForVisits
		},

		[types.STORE_VISITS_CONFIG_BY_CUSTOMER_TYPE] (state, visitsConfigByCustomerType) {
			state.visitsConfigByCustomerType = visitsConfigByCustomerType
		},
	}
}
